import { type PropsWithChildren, type JSX, useEffect, useRef } from 'react';
import { useAppRouter } from '../../../hooks/useAppRouter';

/**
 * Root document `<main>` for the standard (non-iframe) app shell. After client-side
 * navigations, focuses this landmark so keyboard and AT users land on primary content.
 */
export const AppMain = ({ children }: PropsWithChildren): JSX.Element => {
  const mainRef = useRef<HTMLElement>(null);
  const router = useAppRouter();

  useEffect(() => {
    const handleRouteChangeComplete = (): void => {
      requestAnimationFrame(() => {
        mainRef.current?.focus({ preventScroll: true });
      });
    };

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, [router]);

  return (
    <main
      ref={mainRef}
      className='app'
      key='app'
      tabIndex={-1}
      style={{ height: 'inherit', width: 'inherit' }}
    >
      {children}
    </main>
  );
};
